import React, { createContext, useState, useContext, useEffect } from "react";

// Crea il Context per la ricerca avanzata
const AdvSearchCtx = createContext();

// Crea il Provider per il Context
export const AdvSearchProvider = ({ children }) => {
  const [centerCoords, setCenterCoords] = useState({
    lat: 44.801485,
    lng: 10.328,
    radius: 20,
  });
  const [params, setParams] = useState({});

  useEffect(() => {
    if (typeof window === "undefined") return;
    const searchParams = new URLSearchParams(window.location.search);
    const bounds = JSON.parse(searchParams.get("bounds")) || [];
    let center;
    try {
      center = JSON.parse(searchParams.get("center"));
    } catch {
      center = { lat: centerCoords.lat, lng: centerCoords.lng };
    }

    const contratto = searchParams.get("contract") || "vendita";
    const negotiation = searchParams.get("negotiation") || "agenzia";

    setCenterCoords((prev) => ({
      lat: center.lat,
      lng: center.lng,
      ...prev.radius,
      bounds,
    }));
    setParams({
      contratto,
      trattativa: negotiation,
    });
  }, []);

  useEffect(() => {
    if (typeof window === "undefined") return;
    const searchParams = new URLSearchParams();

    //Params
    if (searchParams.get("zone")) {
      searchParams.set("zone", searchParams.get("zone"));
    }
    if (searchParams.get("contract")) {
      searchParams.set("contract", searchParams.get("contract"));
    }
    if (searchParams.get("negotiation")) {
      searchParams.set("negotiation", searchParams.get("negotiation"));
    }

    // Bounds
    if (centerCoords.bounds) {
      searchParams.set("bounds", JSON.stringify(centerCoords.bounds));
    }

    // Center
    if (centerCoords.center) {
      searchParams.set("center", JSON.stringify(centerCoords.center));
    }
  }, [centerCoords, params]);

  const value = {
    centerCoords,
    params,
    setParams,
    setCenterCoords,
  };

  return (
    <AdvSearchCtx.Provider value={value}>{children}</AdvSearchCtx.Provider>
  );
};

// Crea un hook personalizzato per utilizzare il context
export const useAdvSearch = () => {
  const context = useContext(AdvSearchCtx);
  if (!context) {
    throw new Error(
      "useAdvSearch deve essere utilizzato all'interno di un AdvSearchProvider",
    );
  }
  return context;
};
